import React from "react";

export default function Interaction() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="60"
      fill="none"
      viewBox="0 0 76 60"
    >
      <g filter="url(#filter0_d_357_1439)">
        <path
          fill="url(#paint0_linear_357_1439)"
          d="M63.005 43.948c1 0 1.849-.347 2.548-1.041.7-.695 1.05-1.538 1.05-2.53 0-.992-.35-1.836-1.05-2.53-.7-.695-1.549-1.042-2.548-1.042-1 0-1.849.347-2.549 1.042-.7.694-1.049 1.538-1.049 2.53 0 .992.35 1.835 1.05 2.53.699.694 1.548 1.041 2.548 1.041zm0-1.587c-.56 0-1.033-.192-1.42-.575a1.91 1.91 0 01-.579-1.41c0-.555.193-1.024.58-1.408.386-.384.86-.576 1.419-.576.56 0 1.033.192 1.419.576.386.383.58.853.58 1.409a1.91 1.91 0 01-.58 1.408c-.386.384-.86.576-1.42.576zm-6.396 4.365c-.44 0-.816-.155-1.13-.466a1.523 1.523 0 01-.47-1.121v-9.524c0-.437.157-.81.47-1.122.314-.31.69-.466 1.13-.466h2.518l1-1.071c.146-.159.323-.285.53-.377a1.57 1.57 0 01.649-.14h3.398c.226 0 .443.047.65.14.206.092.383.218.53.377l.998 1.071h2.519c.44 0 .816.156 1.13.466.312.311.469.685.469 1.122v9.524c0 .436-.157.81-.47 1.12-.313.312-.69.467-1.129.467H56.609z"
        ></path>
        <path
          fill="url(#paint1_linear_357_1439)"
          d="M14.654 47.342a.694.694 0 01-.63-.149c-.18-.152-.27-.36-.27-.625 0-.185.064-.354.19-.506a.929.929 0 01.47-.307c.333-.08.656-.182.97-.308a5.62 5.62 0 00.91-.466.9.9 0 01.569-.13c.206.02.376.097.51.229.186.185.27.397.25.635a.694.694 0 01-.35.555 7.442 7.442 0 01-1.27.655c-.433.172-.883.311-1.349.417zm3.858-3.393a.787.787 0 01-.23-.496.79.79 0 01.13-.536c.173-.29.326-.588.46-.893.133-.304.24-.628.32-.972a.951.951 0 01.32-.476.8.8 0 01.519-.199c.266 0 .476.093.63.278a.662.662 0 01.13.635c-.107.476-.25.93-.43 1.36-.18.43-.404.836-.67 1.22a.705.705 0 01-.55.327c-.233.02-.443-.063-.63-.248zm1.499-5.159a.762.762 0 01-.51-.198.976.976 0 01-.31-.477 5.839 5.839 0 00-.32-.982 6.516 6.516 0 00-.46-.883.79.79 0 01-.13-.535.787.787 0 01.23-.497c.187-.185.397-.27.63-.257.234.013.417.119.55.317.267.384.493.797.68 1.24.186.443.333.896.44 1.36.053.237 0 .45-.16.634a.803.803 0 01-.64.278zm-8.735 8.532c-1.825-.423-3.328-1.35-4.507-2.778C5.589 43.116 5 41.462 5 39.584c0-1.892.586-3.559 1.759-5 1.173-1.442 2.672-2.362 4.497-2.758a.694.694 0 01.63.148c.18.152.27.354.27.606a.772.772 0 01-.19.506.928.928 0 01-.47.307 6.268 6.268 0 00-3.518 2.242A6.151 6.151 0 006.6 39.584c0 1.481.46 2.788 1.38 3.919a6.537 6.537 0 003.517 2.252.906.906 0 01.47.317c.126.159.19.33.19.516 0 .251-.087.45-.26.595a.684.684 0 01-.62.14zm5.077-13.115a7.905 7.905 0 00-.94-.486 5.86 5.86 0 00-.979-.328.985.985 0 01-.48-.307.75.75 0 01-.2-.506c0-.252.09-.453.27-.606a.694.694 0 01.63-.148c.466.105.92.244 1.36.416.439.172.865.39 1.279.655.213.132.33.318.35.556a.772.772 0 01-.25.634.837.837 0 01-.49.239.815.815 0 01-.55-.12zm-3.378 9.067a.98.98 0 01-.31-.05.629.629 0 01-.25-.148c-.879-.807-1.539-1.56-1.978-2.262-.44-.701-.66-1.35-.66-1.944 0-.926.303-1.7.91-2.322.606-.622 1.369-.933 2.288-.933.92 0 1.682.311 2.289.933.606.622.91 1.395.91 2.322 0 .595-.22 1.243-.66 1.944-.44.701-1.1 1.455-1.98 2.262a.628.628 0 01-.25.149.979.979 0 01-.309.05zm0-3.69c.24 0 .443-.083.61-.248a.82.82 0 00.25-.605.82.82 0 00-.25-.606.832.832 0 00-.61-.248.832.832 0 00-.61.248.82.82 0 00-.25.606c0 .238.084.44.25.605.167.165.37.248.61.248z"
        ></path>
        <path
          fill="url(#paint2_linear_357_1439)"
          d="M31.963 52.679c-.66 0-1.224-.233-1.694-.7a2.285 2.285 0 01-.704-1.681v-21.43c0-.654.234-1.215.704-1.681.47-.467 1.035-.7 1.694-.7h11.993c.66 0 1.224.233 1.694.7.47.466.704 1.026.704 1.681v21.43c0 .654-.235 1.215-.704 1.681-.47.467-1.035.7-1.694.7H31.963zm0-5.953h11.993V32.44H31.963v14.286z"
        ></path>
        <path
          fill="url(#paint3_linear_357_1439)"
          d="M32.362 16.171a.777.777 0 01-.57-.228.765.765 0 01-.23-.565c0-.225.077-.414.23-.566a.777.777 0 01.57-.228h.8V9.028c0-1.098.333-2.073.999-2.927a4.614 4.614 0 012.598-1.676v-.556c0-.33.117-.612.35-.843a1.16 1.16 0 01.85-.347c.333 0 .616.115.849.347.233.231.35.513.35.843v.556A4.614 4.614 0 0141.756 6.1c.666.854 1 1.83 1 2.927v5.556h.8c.226 0 .416.076.569.228.153.152.23.34.23.566a.765.765 0 01-.23.565.777.777 0 01-.57.228H32.362zm5.597 2.381c-.44 0-.817-.155-1.13-.466a1.523 1.523 0 01-.47-1.121h3.199c0 .436-.157.81-.47 1.121-.313.31-.69.466-1.13.466z"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_357_1439"
          width="74.5"
          height="58.5"
          x="0.75"
          y="0.929"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2.5"></feOffset>
          <feGaussianBlur stdDeviation="2.125"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.110987 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_357_1439"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_357_1439"
            result="shape"
          ></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_357_1439"
          x1="2.462"
          x2="2.462"
          y1="-5.26"
          y2="76.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFECDF"></stop>
          <stop offset="0.448" stopColor="#FFFCF1"></stop>
          <stop offset="1" stopColor="#FF9652"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_357_1439"
          x1="2.462"
          x2="2.462"
          y1="-5.26"
          y2="76.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFECDF"></stop>
          <stop offset="0.448" stopColor="#FFFCF1"></stop>
          <stop offset="1" stopColor="#FF9652"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_357_1439"
          x1="2.462"
          x2="2.462"
          y1="-5.26"
          y2="76.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFECDF"></stop>
          <stop offset="0.448" stopColor="#FFFCF1"></stop>
          <stop offset="1" stopColor="#FF9652"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_357_1439"
          x1="2.462"
          x2="2.462"
          y1="-5.26"
          y2="76.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFECDF"></stop>
          <stop offset="0.448" stopColor="#FFFCF1"></stop>
          <stop offset="1" stopColor="#FF9652"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}
